/* istanbul ignore file */
export { default } from './MaxWidthContainer';
